export const CATEGORY_NAME = "title";
export const DESCRIPTION = "description";
export const SUB_CATEGORY = "subCategory";
export const SUB_CATEGORY_NAME = "title";
export const SUB_CATEGORY_DESC = "description";
